import Image1 from '@/assets/images/tutorial/tutorial_1.webp';
import Image2 from '@/assets/images/tutorial/tutorial_2.webp';
import Image3 from '@/assets/images/tutorial/tutorial_3.webp';
import Image4 from '@/assets/images/tutorial/tutorial_4.webp';
import Image5 from '@/assets/images/tutorial/tutorial_5.webp';
import Image6 from '@/assets/images/tutorial/tutorial_6.webp';
import Image7 from '@/assets/images/tutorial/tutorial_7.webp';
import Image8 from '@/assets/images/tutorial/tutorial_8.webp';

import { ContentTutorial } from '../models';

export const NUMBER_START = 0;
export const NUMBER_NEXT = 1;

export const slidesTutorial: ContentTutorial[] = [
  {
    id: 1,
    img: <img src={Image1} width={1051} height={510} />,
    description: 'tutorial:note1'
  },
  {
    id: 2,
    img: <img src={Image2} width={1051} height={510} />,
    description: 'tutorial:note2'
  },
  {
    id: 3,
    img: <img src={Image3} width={1051} height={510} />,
    description: 'tutorial:note3'
  },
  {
    id: 4,
    img: <img src={Image4} width={1051} height={510} />,
    description: 'tutorial:note4'
  },
  {
    id: 5,
    img: <img src={Image5} width={1051} height={510} />,
    description: 'tutorial:note5'
  },
  {
    id: 6,
    img: <img src={Image6} width={1051} height={510} />,
    description: 'tutorial:note6'
  },
  {
    id: 7,
    img: <img src={Image7} width={1051} height={510} />,
    description: 'tutorial:note7'
  },
  {
    id: 8,
    img: <img src={Image8} width={1051} height={510} />,
    description: 'tutorial:note8'
  }
];
